import React from 'react';
// import PropTypes from 'prop-types';
import FormGenerator from './FormGenerator';
import { js_utils } from '../utils/frfr-js-utils';


// FormFieldGenerator STANDALONE with single field definition and standalone value and standalone handleChange. But use FormGenerator under the hood.

const FormFieldGenerator = (props) => {
  let name = "";
  /*
  if (typeof props.name === 'string') {
    name = props.name;
  }
  */
  // console.log('props.fieldDefinition', props.fieldDefinition);
  // console.log('props.fieldDefinition.params.name', props.fieldDefinition.params.name);
  if (props.fieldDefinition && props.fieldDefinition.params && typeof props.fieldDefinition.params.name === 'string') {
    name = props.fieldDefinition.params.name;
  }
  // console.log('name', name);

  /*
  const _standaloneState = {
    [name]: props.value
  }; // state koji sadrzi values od input polja
  */
  const _standaloneState = {}; // state koji sadrzi values od input polja
  _standaloneState[name] = props.value;
  const formState = _standaloneState;
  const _standaloneErrorsState = {}; // state koji sadrzi values od input polja
  if (typeof props.fieldError === 'string' && props.fieldError !== '') {
    _standaloneErrorsState[name] = props.fieldError;
  }
  const formErrors = _standaloneErrorsState; // state for input validation error od input polja

  let handleChange;
  if (typeof props.handleChange === 'function') {
    handleChange = props.handleChange;
  } else {
    handleChange = () => { };
  }

  /*
  let errors = {}; // state koji sadrzi greske za polja koje kreira validator forme
  if (js_utils.is_object(props.formErrors)) {
    errors = props.formErrors;
  }
  */

  return (
    <FormGenerator
      formDefinition={[props.fieldDefinition]}
      formState={formState}
      formErrors={formErrors}
      handleChange={handleChange}
    />
  );
};

/*
FormGenerator.propTypes = {
  formDefinition: PropTypes.array,
  formState: PropTypes.object,
  formErrors: PropTypes.object,
  handleChange: PropTypes.func
};
*/

export default FormFieldGenerator;